(function () {
  'use strict';

  var SELECTOR = '[data-auraa-product-builder]';

  function parseJSON(section) {
    var node = section.querySelector('[data-product-json]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function money(cents, currency) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(2);
    }
  }

  function initGallery(section) {
    var image = section.querySelector('[data-fpb-main-image]');
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-fpb-gallery-dot]'));
    var prev = section.querySelector('[data-fpb-prev]');
    var next = section.querySelector('[data-fpb-next]');
    if (!image || !dots.length) return;

    var index = 0;

    function show(nextIndex) {
      if (!dots.length) return;
      index = (nextIndex + dots.length) % dots.length;
      var dot = dots[index];
      var nextSrc = dot.dataset.src || '';

      if (nextSrc) {
        /* Shopify image_tag adds srcset and sizes. If those remain in place,
           the browser can keep rendering the original responsive source even
           after image.src changes. Remove them before swapping gallery media. */
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.setAttribute('src', nextSrc);
      }

      if (dot.dataset.alt) image.alt = dot.dataset.alt;

      dots.forEach(function (item, itemIndex) {
        var active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () { show(dotIndex); });
    });
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
  }

  function initCollapsibles(section) {
    section.querySelectorAll('[data-auraa-collapsible-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var content = button.parentElement.querySelector('[data-auraa-collapsible-content]');
        if (!content) return;
        var opening = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', opening ? 'true' : 'false');
        content.hidden = !opening;
      });
    });
  }

  function initBuilder(section) {
    if (!section || section.dataset.auraaBuilderReady === 'true') return;
    section.dataset.auraaBuilderReady = 'true';

    initGallery(section);
    initCollapsibles(section);

    var product = parseJSON(section) || {};
    var currency = section.dataset.currency || 'USD';
    var singlePrice = Number(section.dataset.singlePrice || 3490);
    var doublePrice = Number(section.dataset.doublePrice || 3290);
    var triplePrice = Number(section.dataset.triplePrice || 2990);
    var deliveryPrice = Number(section.dataset.deliveryPrice || 500);
    var freeDeliveryQty = Number(section.dataset.freeDeliveryQty || 3);
    var whatsappNumber = section.dataset.whatsappNumber || '';

    var radios = Array.prototype.slice.call(section.querySelectorAll('[data-auraa-bundle-radio]'));
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-auraa-bundle-card]'));
    var threePlus = section.querySelector('[data-auraa-three-plus]');
    var qtyInput = section.querySelector('[data-auraa-qty-input]');
    var qtyMinus = section.querySelector('[data-auraa-qty-minus]');
    var qtyPlus = section.querySelector('[data-auraa-qty-plus]');
    var unitPrice = section.querySelector('[data-auraa-unit-price]');
    var topTotal = section.querySelector('[data-auraa-top-total]');
    var saveBadge = section.querySelector('[data-auraa-save-badge]');
    var summaryLabel = section.querySelector('[data-auraa-summary-label]');
    var summaryTotal = section.querySelector('[data-auraa-summary-total]');
    var form = section.querySelector('[data-auraa-product-form]');
    var variantInput = section.querySelector('[data-auraa-variant-id]');
    var formQuantity = section.querySelector('[data-auraa-form-quantity]');
    var addButton = section.querySelector('[data-auraa-add-button]');
    var addText = section.querySelector('[data-auraa-add-text]');
    var cartMessage = section.querySelector('[data-auraa-cart-message]');
    var deliveryMessage = section.querySelector('[data-auraa-delivery-message]');
    var whatsapp = section.querySelector('[data-auraa-whatsapp]');

    var selectedTier = 1;
    var quantity = 1;

    function getUnitPrice(qty) {
      if (qty >= 3) return triplePrice;
      if (qty === 2) return doublePrice;
      return singlePrice;
    }

    function selectedRadio() {
      return radios.find(function (radio) { return radio.checked; }) || radios[0] || null;
    }

    function setMessage(text, isError) {
      if (!cartMessage) return;
      cartMessage.textContent = text || '';
      cartMessage.classList.toggle('is-error', Boolean(isError));
      cartMessage.classList.toggle('is-visible', Boolean(text));
    }

    function updateWhatsApp(total) {
      if (!whatsapp || !whatsappNumber) return;
      var productTitle = product.title || 'AURAA COFFEE';
      var delivery = quantity >= freeDeliveryQty ? ' + Free Delivery' : ' + ' + money(deliveryPrice, currency) + ' Delivery';
      var message = 'Hello I am interested to buy ' + productTitle + ' x' + quantity + ' for ' + money(total, currency) + delivery;
      whatsapp.href = 'https://wa.me/' + encodeURIComponent(whatsappNumber) + '?text=' + encodeURIComponent(message);
    }

    function updateUI() {
      var radio = selectedRadio();
      selectedTier = radio ? Number(radio.value || 1) : 1;

      if (selectedTier >= 3) {
        quantity = Math.max(3, Number(qtyInput && qtyInput.value ? qtyInput.value : 3));
        if (qtyInput) qtyInput.value = String(quantity);
        if (threePlus) threePlus.hidden = false;
      } else {
        quantity = selectedTier;
        if (threePlus) threePlus.hidden = true;
      }

      cards.forEach(function (card) {
        card.classList.toggle('is-selected', Number(card.dataset.tier) === selectedTier);
      });

      var each = getUnitPrice(quantity);
      var total = each * quantity;
      var regular = singlePrice * quantity;
      var savings = Math.max(0, regular - total);

      if (unitPrice) unitPrice.textContent = money(each, currency);
      if (topTotal) topTotal.textContent = money(total, currency) + ' TOTAL';
      if (summaryLabel) summaryLabel.textContent = quantity + (quantity === 1 ? ' AURAA' : ' AURAA');
      if (summaryTotal) summaryTotal.textContent = money(total, currency);
      if (formQuantity) formQuantity.value = String(quantity);

      if (saveBadge) {
        if (savings > 0) {
          saveBadge.textContent = 'SAVE ' + money(savings, currency);
          saveBadge.classList.remove('is-hidden');
        } else {
          saveBadge.textContent = '';
          saveBadge.classList.add('is-hidden');
        }
      }

      if (deliveryMessage) {
        if (quantity >= freeDeliveryQty) {
          deliveryMessage.innerHTML = '<strong>FREE DELIVERY</strong> WITH DELIVERY IN 1 TO 3 BUSINESS DAYS';
        } else {
          deliveryMessage.innerHTML = '<strong>' + money(deliveryPrice, currency) + ' DELIVERY</strong> WITH DELIVERY IN 1 TO 3 BUSINESS DAYS';
        }
      }

      if (addText && addButton && !addButton.disabled) {
        addText.textContent = 'ADD ' + quantity + ' TO CART  •  ' + money(total, currency);
      }

      updateWhatsApp(total);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', updateUI);
    });

    function selectThreePlus() {
      var three = radios.find(function (radio) { return Number(radio.value) === 3; });
      if (three) three.checked = true;
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        selectThreePlus();
        var current = Math.max(3, Number(qtyInput && qtyInput.value ? qtyInput.value : 3));
        if (qtyInput) qtyInput.value = String(Math.max(3, current - 1));
        updateUI();
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        selectThreePlus();
        var current = Math.max(3, Number(qtyInput && qtyInput.value ? qtyInput.value : 3));
        if (qtyInput) qtyInput.value = String(Math.min(99, current + 1));
        updateUI();
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        selectThreePlus();
        qtyInput.value = String(Math.min(99, Math.max(3, Number(qtyInput.value || 3))));
        updateUI();
      });
    }

    async function fallbackAdd(variantId, qty) {
      var root = section.dataset.rootUrl || '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add to cart');

      var cartResponse = await fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      var cart = await cartResponse.json();
      document.dispatchEvent(new CustomEvent('auraa:cart:updated', { detail: { cart: cart } }));
      if (typeof window.openAuraaCartDrawer === 'function') window.openAuraaCartDrawer();
      return data;
    }

    if (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (!addButton || addButton.disabled) return;

        var variantId = variantInput ? Number(variantInput.value) : 0;
        if (!variantId) {
          setMessage('Choose AURAA COFFEE in the section settings.', true);
          return;
        }

        var defaultText = addButton.dataset.defaultText || 'ADD TO CART';
        var loadingText = addButton.dataset.loadingText || 'ADDING';
        addButton.disabled = true;
        if (addText) addText.textContent = loadingText;
        setMessage('', false);

        try {
          if (window.AuraaCart && typeof window.AuraaCart.add === 'function') {
            await window.AuraaCart.add(variantId, quantity);
          } else {
            await fallbackAdd(variantId, quantity);
          }
          setMessage('Added to cart', false);
        } catch (error) {
          setMessage(error && error.message ? error.message : 'Unable to add to cart', true);
        } finally {
          addButton.disabled = false;
          updateUI();
          if (addText && !addText.textContent) addText.textContent = defaultText;
        }
      });
    }

    updateUI();
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.matches && event.target.matches(SELECTOR)) initBuilder(event.target);
    else initAll(event.target);
  });
})();